import { StyleSheet } from 'aphrodite';
import { defaultStyles } from '../../..';

const styles = StyleSheet.create({
    packagingButton: {
        position: 'relative',
        flex: '0 0 100%',
        maxWidth: '100%',
        padding: '0 10px',
        margin: '5px 0',
        '@media screen and (min-width: 768px)': {
            flex: '0 0 33.333333%',
            maxWidth: '33.333333%',
            margin: '10px 0',
        }
    },
    check: {
        position: 'absolute',
        width: '20px',
        right: '2.5vmin',
        top: '50%',
        transform: 'translateY(-50%)',
    },
    packagingButtonInner: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: '100%',
        minHeight: '60px',
        textAlign: 'center',
        textTransform: 'uppercase',
        border: '1px solid ' + defaultStyles.greyBackground,
        backgroundColor:  defaultStyles.greyBackground,
        padding: '1vmin 5vmin',
        color: defaultStyles.greyText,
        cursor: 'pointer',
        zIndex: 1,
        '@media screen and (min-width: 768px)': {
            height: '100%',
            minHeight: '80px',
        }
    },
    selected: {
        color: defaultStyles.blue,
        borderColor: defaultStyles.blue,
        backgroundColor: defaultStyles.greyBackground,
    },
    openedButton: {
        '@media screen and (max-width: 767px)': {
            borderColor: defaultStyles.greyLight,
        }
    },
    packagingContainer: {
        maxHeight: '0px',
        overflow: 'hidden',
        transition: 'max-height .3s ease',
    },
    openedpackaging: {
        marginTop: '32px',
        maxHeight: '1500px',
        '@media screen and (min-width: 768px)': {
            display: 'none',
        },
    },
    packagingSelectionButtonWrapper: {
        border: '1px solid ' + defaultStyles.greyLight,
        borderTop: 'none',
        padding: '10px',
        backgroundColor: defaultStyles.white,
        marginTop: '-2px',
    },
    packagingSelectionButton: {
        display: 'none',
        '@media screen and (min-width: 768px)': {
            display: 'block',
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: 2,
            opacity: 0,
            cursor: 'pointer',
        }
    },
    opened: {
        '@media screen and (max-width: 767px)': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid ' + defaultStyles.blue,
            backgroundColor: defaultStyles.blue,
            color: defaultStyles.white,
            padding: '10px',
            cursor: 'pointer',
            textTransform: 'uppercase',
        }
    },
    addIcon: {
        width: '20px',
        marginRight: '10px',
        transform: 'translateY(-2px)',
    },
    span: {
        userSelect: 'none',
    }
});

export default styles;
